import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
    useTheme,
} from '@mui/material'
import { FC, useState } from 'react'
import CloseCircleIcon from '../../../../assets/icons/CloseCircle.svg?react'
import MessageQuestionCircleIcon from '../../../../assets/icons/MessageQuestionCircle.svg?react'

export const MobileHelpButton: FC = () => {
    const { breakpoints } = useTheme()

    const [isOpen, setIsOpen] = useState(false)

    const handleOpenDialog = () => {
        setIsOpen(true)
    }

    const handleCloseDialog = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Dialog
                open={isOpen}
                onClose={handleCloseDialog}
                sx={{
                    [breakpoints.down('md')]: {
                        '.MuiDialog-container': {
                            alignItems: 'flex-end',
                        },
                        '.MuiPaper-root': {
                            m: 0,
                            borderRadius: 0,
                            height: '100%',
                            maxHeight: 'unset',
                        },
                        '.MuiDialogContent-root': {
                            pt: '16px !important',
                        },
                    },
                }}>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        m: 0,
                        p: 2,
                    }}>
                    <IconButton
                        onClick={handleCloseDialog}
                        sx={{
                            p: 0,
                        }}>
                        <CloseCircleIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Stack gap={2.5}>
                        <Stack gap={2}>
                            <Typography variant="h5">
                                Чтобы получить лучший результат, давайте ИИ четкую задачу
                            </Typography>
                            <Stack gap={1.5}>
                                <Typography variant="h6">
                                    Попробуйте эту простую формулу:
                                </Typography>
                                <Stack gap={1}>
                                    <Typography variant="body2" sx={{ display: 'ruby' }}>
                                        <Typography variant="h6">• Роль:</Typography> Назначьте ИИ
                                        эксперта
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'ruby' }}>
                                        <Typography variant="h6">• Задача:</Typography> Опишите, что
                                        нужно сделать
                                    </Typography>
                                    <Typography variant="body2" sx={{ display: 'ruby' }}>
                                        <Typography variant="h6">• Детали:</Typography> Добавьте
                                        контекст — тему, целевую аудиторию, стиль, формат
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack gap={1.5}>
                            <Typography variant="h6">Пример промпта:</Typography>
                            <Typography variant="body2">
                                Представь, что ты опытный шеф-повар и специалист по планированию
                                меню. Составь план ужинов на рабочую неделю (с понедельника по
                                пятницу). Семья из трёх человек: двое взрослых и ребёнок 10 лет. Мы
                                хотим, чтобы блюда были разнообразными, полезными и готовились не
                                дольше 40 минут. Пожалуйста, исключи из меню жареное и морепродукты
                                (кроме рыбы). К каждому ужину предложи простой гарнир. Цель —
                                сэкономить время и питаться сбалансированно. Отвечай дружелюбно, как
                                будто ты заботливая бабушка, рассказывающая меню внуку.
                            </Typography>
                        </Stack>
                        <Typography variant="h6">
                            Постарайтесь дать максимум информации в одном запросе. Чем больше
                            подробностей и ясности в вашем запросе, тем точнее и полезнее будет
                            ответ.
                        </Typography>
                    </Stack>
                </DialogContent>
                <DialogActions
                    sx={{
                        borderTop: '1px solid #F4F4F6',
                        [breakpoints.down('md')]: {
                            p: 2,
                            pb: 2.5,
                        },
                    }}>
                    <Button fullWidth variant="contained" onClick={handleCloseDialog}>
                        Понятно
                    </Button>
                </DialogActions>
            </Dialog>

            <IconButton
                onClick={handleOpenDialog}
                sx={{
                    position: 'absolute',
                    zIndex: 99,
                    top: 6,
                    right: 6,
                    color: '#8F93A3',
                    ':hover': {
                        color: '#006CFD',
                    },
                }}>
                <MessageQuestionCircleIcon />
            </IconButton>
        </>
    )
}
